import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  data: [],
  pages: {
    pageNo: 1,
    totalPages: 1,
    pageSize: 10,
    totalElements: 5
  }
};

const uploadHistorySlice = createSlice({
  name: 'uploadHistory',
  initialState,
  reducers: {
    setUploadHistory(state, action) {
      return action.payload;
    }
  }
});

export const { setUploadHistory } = uploadHistorySlice.actions;

export default uploadHistorySlice.reducer;
